module.exports = __webpack_public_path__ + "img/face3.cc576931.png";